module.exports = __webpack_public_path__ + "img/风筝.7dbb5ba0.jpg";